var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, _vm._l(_vm.marks, function (mark, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "6",
        "md": "4",
        "lg": "2"
      }
    }, [_c('v-card', {
      staticClass: "mark-card rounded-xl",
      attrs: {
        "outlined": "",
        "min-height": "120"
      }
    }, [_c('div', [_c('v-img', {
      staticClass: "mx-auto",
      attrs: {
        "max-width": "154",
        "src": mark.logo,
        "alt": mark.name
      }
    })], 1)])], 1);
  }), 1);

}
var staticRenderFns = []

export { render, staticRenderFns }